{
  "deprecatedBrowser": "Your browser is not supported",
  "deprecatedBrowserHelpText": "Consider updating your browser to the latest version to ensure the best experience."
} 
